<template>
  <!-- a rx ry x-axis-rotation large-arc-flag sweep-flag dx dy -->
  <path
    d="M 25,50 a10 10 0 0 0 10 -10 v-20 a10 10 0 0 1 20 0 v60 a10 10 0 0 0 20 0 v-60 a10 10 0 0 1 20 0 v60 a10 10 0 0 0 20 0 v-20 a10 10 0 0 1 10 -10"
    fill="none"
  />
</template>
